export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para seleccionar qué columnas mostrar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Columnas mostradas"])}
}